import * as Location from 'expo-location';
import * as Notifications from 'expo-notifications';

import Logger from 'app/services/Logger';

const MODULE = '[PermissionsService]';

/**
 * Requests the notification and location permissions needed for geofenced
 * notifications. Only prompts for permissions that have not been answered yet.
 */
export async function requestPermissions() {
  // push notifications permissions
  const currentNotificationsStatus = await Notifications.getPermissionsAsync();

  if (areNotificationsGranted(currentNotificationsStatus)) {
    Logger.debug(`${MODULE} notifications already granted`);
  } else if (currentNotificationsStatus.canAskAgain) {
    const requestedNotificationsStatus = await Notifications.requestPermissionsAsync();

    if (areNotificationsGranted(requestedNotificationsStatus)) {
      Logger.debug(`${MODULE} notifications permission granted`);
    } else {
      Logger.info(`${MODULE} notifications permission ${requestedNotificationsStatus.status}`);
    }
  } else {
    Logger.debug(`${MODULE} notifications ${currentNotificationsStatus.status}, cannot ask again`);
  }

  // location permissions for geofenced notifications
  const currentForegroundStatus = await Location.getForegroundPermissionsAsync();

  if (currentForegroundStatus.status !== 'granted' && currentForegroundStatus.canAskAgain) {
    const requestedForegroundStatus = await Location.requestForegroundPermissionsAsync();

    if (requestedForegroundStatus.status !== 'granted') {
      Logger.info(`${MODULE} foreground location denied`);
    }
  }
}

function areNotificationsGranted(status: Notifications.NotificationPermissionsStatus) {
  return status.granted || status.ios?.status === Notifications.IosAuthorizationStatus.PROVISIONAL;
}
